import { render } from "./OekostromButton.vue?vue&type=template&id=2f5c3bfd&ts=true"
import script from "./OekostromButton.vue?vue&type=script&lang=ts"
export * from "./OekostromButton.vue?vue&type=script&lang=ts"

import "./OekostromButton.vue?vue&type=style&index=0&id=2f5c3bfd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__